import axios from "./base";

const config = {
  withCredentials: true
};

const apiRequest = {
  get: link => {
    return new Promise((resolve, reject) => {
      axios
        .get(link, config)
        .then(onFulfilled => resolve(onFulfilled))
        .catch(onRejected => reject(onRejected));
    });
  },
  post: (link, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(link, data, config)
        .then(onFulfilled => resolve(onFulfilled))
        .catch(onRejected => reject(onRejected));
    });
  },
  put: (link, data) => {
    return new Promise((resolve, reject) => {
      axios
        .put(link, data, config)
        .then(onFulfilled => resolve(onFulfilled))
        .catch(onRejected => reject(onRejected));
    });
  },
  patch: (link, data) => {
    return new Promise((resolve, reject) => {
      axios
        .patch(link, data, config)
        .then(onFulfilled => resolve(onFulfilled))
        .catch(onRejected => reject(onRejected));
    });
  },
  delete: link => {
    return new Promise((resolve, reject) => {
      axios
        .delete(link, config)
        .then(onFulfilled => resolve(onFulfilled))
        .catch(onRejected => reject(onRejected));
    });
  },
  upload: (link, data) => {
    return axios({
      cache: false,
      contentType: "multipart/form-data",
      data,
      method: "post",
      processData: false,
      url: link,
      withCredentials: true
    });
  }
};

export default apiRequest;
